import React, { useState } from 'react';
import { api } from '../../lib/api';
import '../../styles/home.css';

// Promoções & sorteios — consentimento de canal EXPLÍCITO (alinhado ao FAQ #6):
// e-mail sempre on; WhatsApp opcional (campo condicionado). Marcação exata da proposta.
interface StelaLead {
  nome?: string;
  email?: string;
  whatsapp?: string;
}

function readLead(): StelaLead {
  try {
    return (JSON.parse(sessionStorage.getItem('stela.lead') ?? 'null') ?? {}) as StelaLead;
  } catch {
    return {};
  }
}

function saveLead(update: Partial<StelaLead>) {
  try {
    sessionStorage.setItem('stela.lead', JSON.stringify({ ...readLead(), ...update }));
  } catch {
    // ok sem memória
  }
}

export const Promotions: React.FC = () => {
  const prefill = readLead();
  const [nome, setNome] = useState(prefill.nome ?? '');
  const [email, setEmail] = useState(prefill.email ?? '');
  const [whatsapp, setWhatsapp] = useState(prefill.whatsapp ?? '');
  const [loading, setLoading] = useState(false);
  const [ok, setOk] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);


  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!nome.trim() || !email.trim()) {
      setError('Preencha nome e e-mail');
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await api.post('/leads', {
        kind: 'newsletter',
        nome: nome.trim(),
        email: email.trim().toLowerCase(),
        whatsapp: whatsapp.trim() || undefined,
      });
      setOk('Pronto! Você está na lista.');
      saveLead({ nome: nome.trim(), email: email.trim().toLowerCase(), whatsapp: whatsapp.trim() || undefined });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Não deu para entrar na lista agora');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="promocoes" className="canal">
      <div className="box">
        <div className="kicker">Promoções & sorteios</div>
        <h3>Entre na lista: promoções antes de todo mundo</h3>
        <p>Todo mês tem sorteio de consulta grátis e descontos que não vão pro site — quem está na lista fica sabendo primeiro. E de brinde, o horóscopo semanal da Stela.</p>

        {ok ? (
          <div className="ok" role="status" aria-live="polite">{ok}</div>
        ) : (
          <form onSubmit={submit} noValidate>
            <div className="grid3">
              <input
                type="text"
                name="nome"
                placeholder="Seu nome"
                aria-label="Seu nome"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                aria-invalid={!!error}
                aria-describedby={error ? 'promo-error' : undefined}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Seu e-mail"
                aria-label="Seu e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                aria-invalid={!!error}
                aria-describedby={error ? 'promo-error' : undefined}
                required
              />
              <input
                type="tel"
                name="whatsapp"
                placeholder="WhatsApp (21) 9 0000-0000"
                pattern="[0-9()+\-\s]{10,20}"
                aria-label="Seu WhatsApp"
                value={whatsapp}
                onChange={(e) => setWhatsapp(e.target.value)}
                required
              />
            </div>
            <button className="btn" type="submit" disabled={loading}>
              {loading ? 'Enviando…' : 'Quero participar das promoções'}
            </button>
            {error && (
              <p id="promo-error" role="alert" style={{ color: '#E08C8C', fontSize: 12.5, marginTop: 8 }}>
                {error}
              </p>
            )}
          </form>
        )}

        <div className="perks">
          <span>sorteio mensal de consultas</span>
          <span>descontos exclusivos de créditos</span>
          <span>horóscopo semanal da Stela</span>
          <span>sair quando quiser</span>
        </div>
      </div>
    </section>
  );
};
